<template>
  <runtime-template :template="template"></runtime-template>
</template>

<script>
import RuntimeTemplate from 'v-runtime-template';

export default {
  components: {
    RuntimeTemplate,
  },
  props: {
    tag: {
      default: 'div',
    },
    html: {
      default: '',
    },
  },
  computed: {
    template() {
      return `<component is="${this.tag}">${this.processedHtml}</component>`;
    },
    processedHtml() {
      return this.html.replace(/<a.*?href=(["'])(.*?)\1.*?>(.*?)<\/a>/g, (match, quote, href, text) => {
        let path = href;

        if (/^http/.test(href)) {
          let url;
          try {
            url = new URL(href);
            if (url.host !== window.location.host) {
              return match;
            }
          } catch {
            return match;
          }

          path = url.pathname + url.search + url.hash;
        }

        if (/\.(html|php|exe|AppImage)/.test(path)) {
          return `<a href="https://appdb.to/${path}">${text}</a>`;
        }

        if (/^mailto/.test(path)) {
          return match;
        }

        return `<router-link to="${path}">${text}</router-link>`;
      });
    },
  },
};
</script>
